<template>
  <button
    type="button"
    class="pv-trend-icon"
    :title="'출력량 추이' | translate"
    @click.stop="$emit('click', $event)"
  >
    <v-icon x-small>mdi-chart-line</v-icon>
  </button>
</template>

<script>
export default {
  name: 'PrintVolumeTrendIcon',
}
</script>

<style scoped>
.pv-trend-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  margin-left: 4px;
  padding: 0;
  border: 0;
  border-radius: 4px;
  background: transparent;
  color: #64748b;
  cursor: pointer;
  vertical-align: middle;
  flex-shrink: 0;
}
.pv-trend-icon:hover {
  background: #eff6ff;
  color: #0c98fe;
}
</style>
